import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567702137.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "item"
  }, [_vm._m(0), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("温度")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.weatherData.temp) + " "), _c("span", [_vm._v("℃")])])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(1), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("湿度")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.weatherData.rh) + " "), _c("span", [_vm._v("%")])])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(2), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("风力")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value",
    staticStyle: {
      "font-size": "0.9vw"
    }
  }, [_vm._v(_vm._s(_vm.weatherData.wind_class))])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(3), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("风向")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value",
    staticStyle: {
      "font-size": "0.9vw"
    }
  }, [_vm._v(_vm._s(_vm.weatherData.wind_dir))])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(4), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("天气")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value",
    staticStyle: {
      "font-size": "0.9vw"
    }
  }, [_vm._v(_vm._s(_vm.weatherData.text))])]), _c("div", {
    staticClass: "line"
  })])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside1.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "center-content"
  }, _vm._l(_vm.structures_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "item-header"
    }, [_c("img", {
      attrs: {
        src: require("./image/workshop/item-header.png"),
        alt: ""
      }
    }), _c("div", [_c("div", {
      staticClass: "name one-overflow"
    }, [_vm._v("池:" + _vm._s(item.name))]), _c("div", {
      staticClass: "breed"
    }, [_vm._v(" 品种：" + _vm._s(item.species || "--") + " ")])])]), _c("div", {
      staticClass: "item-content"
    }, [_vm._m(5, true), _c("div", {
      staticClass: "table-content"
    }, [_vm._l(item.taskList, function (opt, idx) {
      return _c("div", {
        key: opt.id,
        staticClass: "tr"
      }, [_c("div", {
        staticClass: "td",
        staticStyle: {
          "min-width": "135px"
        }
      }, [_vm._v(_vm._s(_vm.dayjs(opt.executeDate).format("YYYY-MM-DD HH:mm")))]), _c("div", {
        staticClass: "td",
        staticStyle: {
          flex: "none",
          width: "100px"
        }
      }, [_vm._v(_vm._s(_vm.category[opt.category]))]), _c("div", {
        staticClass: "td",
        staticStyle: {
          flex: "none",
          width: "85px"
        }
      }, [opt.state === "Wait" ? _c("div", {
        staticClass: "text-lose"
      }, [_vm._v("待执行")]) : _vm._e(), opt.state === "End" ? _c("div", {
        staticClass: "text-suggest"
      }, [_vm._v("已执行")]) : _vm._e()]), _c("div", {
        staticClass: "td",
        staticStyle: {
          "min-width": "85px"
        }
      }, [_vm._v(_vm._s(opt.executeUserNickname || "--"))]), _c("div", {
        staticClass: "td operate",
        staticStyle: {
          flex: "none",
          width: "100px"
        }
      }, [opt.state === "Wait" ? _c("div", {
        on: {
          click: function click($event) {
            return _vm.handle(opt.id);
          }
        }
      }, [_vm._v(" 执行 "), _c("i", {
        staticClass: "el-icon-caret-right"
      })]) : _vm._e(), _c("div", {
        on: {
          click: function click($event) {
            return _vm.look(opt);
          }
        }
      }, [_vm._v(" 查看 "), _c("i", {
        staticClass: "el-icon-caret-right"
      })])])]);
    }), !item.taskList.length ? _c("div", {
      staticClass: "block"
    }, [_vm._v("暂无任务数据")]) : _vm._e()], 2)])]);
  }), 0), _c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside2.png"),
      alt: ""
    }
  })])]), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: "养殖任务详情",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: {}
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属企业",
      "label-width": _vm.formLabelWidth,
      prop: "labId"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属企业"
    },
    model: {
      value: _vm.formData.labName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "labName", $$v);
      },
      expression: "formData.labName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属养殖区域",
      "label-width": _vm.formLabelWidth,
      prop: "areaId"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属养殖区域"
    },
    model: {
      value: _vm.formData.areaName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "areaName", $$v);
      },
      expression: "formData.areaName"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "任务类别",
      "label-width": _vm.formLabelWidth,
      prop: "category"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请输入任务类别"
    },
    model: {
      value: _vm.category[_vm.formData.category],
      callback: function callback($$v) {
        _vm.$set(_vm.category, _vm.formData.category, $$v);
      },
      expression: "category[formData.category]"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "执行日期",
      "label-width": _vm.formLabelWidth,
      prop: "executeDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "请选择执行日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.formData.executeDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "executeDate", $$v);
      },
      expression: "formData.executeDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "执行人",
      "label-width": _vm.formLabelWidth,
      prop: "executeUser"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择执行人"
    },
    model: {
      value: _vm.formData.executeUserNickname,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "executeUserNickname", $$v);
      },
      expression: "formData.executeUserNickname"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "执行内容",
      "label-width": _vm.formLabelWidth,
      prop: "executeContent"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      type: "textarea",
      rows: 5,
      placeholder: "请输入执行内容"
    },
    model: {
      value: _vm.formData.executeContent,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "executeContent", $$v);
      },
      expression: "formData.executeContent"
    }
  })], 1)], 1)], 1), _c("el-dialog", {
    attrs: {
      visible: _vm.handleDialogShow,
      title: "执行任务",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.handleDialogShow = $event;
      },
      close: function close($event) {
        _vm.handleData = {};
      }
    }
  }, [_c("el-form", {
    ref: "handleformDataVerify",
    attrs: {
      model: _vm.handleData,
      rules: _vm.handleRules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "操作时间",
      "label-width": _vm.formLabelWidth,
      prop: "operateDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "请选择操作时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.handleData.operateDate,
      callback: function callback($$v) {
        _vm.$set(_vm.handleData, "operateDate", $$v);
      },
      expression: "handleData.operateDate"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "操作内容",
      "label-width": _vm.formLabelWidth,
      prop: "operateContent"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      placeholder: "请输入操作内容"
    },
    model: {
      value: _vm.handleData.operateContent,
      callback: function callback($$v) {
        _vm.$set(_vm.handleData, "operateContent", $$v);
      },
      expression: "handleData.operateContent"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        ;
        _vm.handleDialogShow = false, _vm.handleData = {};
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitHandleData
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/RoomTemperature.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/RoomHumidity.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/fl.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/fx.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/RoomIllumination.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-header"
  }, [_c("div", {
    staticStyle: {
      "min-width": "135px"
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/largeProduct/icon3.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("执行时间")])]), _c("div", {
    staticStyle: {
      flex: "none",
      width: "100px"
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/largeProduct/icon1.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("任务内容")])]), _c("div", {
    staticStyle: {
      flex: "none",
      width: "85px"
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/largeProduct/icon2.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("任务状态")])]), _c("div", {
    staticStyle: {
      "min-width": "85px"
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/largeProduct/icon4.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("执行人")])]), _c("div", {
    staticStyle: {
      flex: "none",
      width: "100px"
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/largeProduct/icon5.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("操作")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };